// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { buildCompanyPath } from '../utils/landingCompany';

// When used as an element in router config with nested routes,
// React Router renders children via <Outlet />. Protect by rendering
// the outlet only when user is authenticated.
const ProtectedRoute = () => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to={buildCompanyPath("")} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;